export default "__VITE_ASSET__6858a6c7__"